/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as DropdownIcon } from '../../icons/dropdown-arrow.svg';
import { ReactComponent as DropdownExpand } from '../../icons/arrow-expand.svg';
import './MultiLevelDropdown.less';

export const MultiLevelDropdown = (props) => {
  const { filter, items, placeholder, theme } = props;
  const [toggleOpen, setToggleOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current.contains(e.target)) {
        setToggleOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const renderItems = (items, level = 0) => (
    <div className={`dropdownLevel level-${level} mld-${theme}`}>
      {items.map((item) => {
        const hasChildren = item.children && item.children.length > 0;
        return (
          <div className="dropdownOptionWrapper" key={item.label}>
            <div className="dropdownOption" onClick={item.callback} data-testid={`${level === 1 ? 'dropdown-submenu' :""}`}>
              {item.label}
              {hasChildren && <span className="submenu-arrow"><DropdownExpand /></span>}
            </div>
            {hasChildren && (
              <div className="submenu">
                {renderItems(item.children, level + 1)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  return (
    <div
      className={`multi-level-dropdown mld-${theme}`}
      data-testid="dropdown-button"
      onClick={() => setToggleOpen(!toggleOpen)}
      ref={dropdownRef}
    >
      <div className={`${filter[0] || filter[1] ? 'active' : ""}`}>{filter[0] ? filter [0] : filter[1] ? filter[1] : placeholder}</div>
      {toggleOpen && <div className="mldWrapper">{renderItems(items)}</div>}
      <div className="arrow-container">
        <DropdownIcon color={!toggleOpen ? '#4A5866' : '#06b2bc'} />
      </div>
    </div>
  );
};